module.exports = __webpack_public_path__ + "static/media/frita-logo.95b3ac81.png";